<template>
   <v-container> 
      <v-card-text>
        <advance-filter
          ref="advanceFillterRef"
          :column="filterColumn"
          @getList="fetchPagesItems"
          @saveFilter="saveFilter"
          :savedFilters="savedFilters"
          class="mb-5 mt-n8"
        ></advance-filter>
        <v-col cols="12" md="4">
        <v-text-field
        class="mt-n5"
        v-model="search"
        type="text"
        placeholder="عنوان جستجو را بنویسید"
        outlined
        dense
        label="جستجو"
        @input="searchPage"
      />
        </v-col>
        <v-data-table
          :loading="loadingPagesTable"
          :items="pagesItems"
          :headers="PagesHeader"
          class="elevation-1"
          disable-pagination
          hide-default-footer
        >
        <template v-slot:[`item.indexImageId`]="{ item }">
        <v-img 
              width="50"
              height="50"
        :src="item.indexImageId ? item.indexImageId.thumbnailFileUrl : ''" />
      </template>
          <template v-slot:[`item.summary`]="{ item }">
            {{
              item.summary.length > 30
                ? item.summary.slice(0, 30) + "..."
                : item.summary
            }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
             <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                @click="showPage(item)"
                >
                  <v-icon color="primary" dark v-bind="attrs" v-on="on">
                    mdi-eye
                  </v-icon>
                </v-btn>
              </template>
              <span>نمایش</span>
            </v-tooltip>
             <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                :disabled="item.publishRequestStatus == 'Processing' || item.publishRequestStatus == 'Rejected' || !item.approved? true:false"
                icon
                @click="publishRequest(item)"
                >
                  <v-icon color="primary" dark v-bind="attrs" v-on="on">
                    mdi-send
                  </v-icon>
                </v-btn>
              </template>
              <span>ارسال برای انتشار در سایت اصلی</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                @click="editPage(item)"
                >
                  <v-icon color="primary" dark v-bind="attrs" v-on="on">
                    mdi-lead-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>ویرایش</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="error" @click="deletePage(item)"
              ><v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon></v-btn
            >
              </template>
              <span>حذف</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.disabled`]="{ item }">
            <v-switch
                @click="changeStatus(item)"
                dense
                v-model="item.disabled"
                :false-value="true"
                :true-value="false"
        ></v-switch>
          </template>
          <template v-slot:[`item.approved`]="{ item }">
          
            <v-switch
                @click="changeApprovalStatus(item)"
                dense
                v-model="item.approved"
                
                ></v-switch>
          </template>
          <template v-slot:[`item.commentable`]="{ item }">
          
            <v-switch
                @click="changeCommentStatus(item)"
                dense
                v-model="item.commentable"
                ></v-switch>
          </template>
        </v-data-table>
        <div class="text-center pt-5">
          <v-row>
            <v-col cols="12" sm="2" md="2">
              <v-select
                outlined
                dense
                v-model="itemsPerPage"
                :items="[5, 10, 20]"
                label="تعداد نمایش در صفحه"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="10" md="10">
              <v-pagination
                circle
                v-model="pageNumber"
                :length="pageCount"
                :total-visible="7"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
  </v-container> 
 
</template>

<script>
import { RepoFactory } from "@/baseRepository/Factory";
const pagesRepository = () => RepoFactory.get("pages");
const enumsRepository = () => RepoFactory.get("enums");
import Helper from "@/core/helpers";
import qs from "qs";
import AdvanceFilter from "@/components/core/AdvanceFilter";

export default {
  data() {
    return {
       filterColumn:[],
      savedFilters:[],
      search:'',
      pagesItems: [],
      pageNumber: 1,
      itemsPerPage: 10,
      pageCount: 0,
      loadingPagesTable: true,
      PagesHeader: [
        {
          value: "indexImageId",
          text: "عکس شاخص",
          sortable: true,
        },
        {
          value: "title",
          text: "عنوان",
          sortable: true,
        },
        {
          value: "summary",
          text: "خلاصه",
          sortable: true,
        },

        {
          value: "disabled",
          text: "فعال/غیرفعال",
          sortable: false,
        },
        {
          value: "approved",
          text: "تاییدشده/ردشده",
          sortable: false,
        },
        {
          value: "commentable",
          text: "ثبت نظر",
          sortable: false,
        },
        {
          value: "actions",
          text: "عملیات",
        },
      ],
      
    };
  },
  created() {
     this.getClassTypeModel();
    if (localStorage.getItem("supplierPagesFilter")) {
      this.savedFilters = JSON.parse(localStorage.getItem("supplierPagesFilter"));
    }
    if(this.currentMerchant!= null){
    this.fetchPagesItems();}
  },
  computed: {
    baseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    currentMerchant() {
      return this.$store.getters.currentMerchant;
    },
  },
  watch: {
    currentMerchant(){
      this.fetchPagesItems();
    },
    pageNumber() {
      this.fetchPagesItems();
    },
    itemsPerPage() {
      this.fetchPagesItems();
    },
    search(val) {
      if (val && val.length >= 3) {
        this.searchPage(val)
      }
      else{
        this.fetchPagesItems();
      }
    }
  },
  methods: {
   getClassTypeModel() {
      enumsRepository()
        .getModel("PageListDto", this.baseUrl)
        .then((res) => {
          this.filterColumn = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    saveFilter(){
      localStorage.setItem(
        "supplierPagesFilter",
        JSON.stringify(this.$refs.advanceFillterRef.Filters)
      );
    
    },
    searchPage(query) {
      if (query && query.length >= 3) {
      const loader = this.$loading.show()
      let params={key:query}
       pagesRepository()
        .getPagesWithFilter(
          this.baseUrl,
         {MerchantId: this.$store.getters.currentMerchant},
          params
        )
          .then((result) => {
            this.pagesItems = result.data;
            this.pageCount = 1;
          })
          .catch((err) => {
            Helper.handleErrors(err, this);
          })
          .finally(()=> loader.hide())

      }
    },
    openCreateForm() {
    this.$store.commit('setPagesFormStatus', true)
    },
    fetchPagesItems() {
      let app = this;
      this.pagesItems = [];
      let params = {
        PageNumber: this.pageNumber,
        ItemsPerPage: this.itemsPerPage,
      };
      if (
        (this.$refs.advanceFillterRef &&
        this.$refs.advanceFillterRef.Filters.length)
   
      ) {
        params.Filters = this.$refs.advanceFillterRef.Filters;

        params.Filters.forEach((element) => {
          delete element.arrayOfValue;
          delete element.enumValues;
          delete element.type;
          delete element.typeOfValue;
        });
      }
       if (this.savedFilters && this.savedFilters.length){
        if(params.Filters && params.Filters.length){
        params.Filters.concat(this.savedFilters)}
        else{
        params.Filters = this.savedFilters

        }
       }
      const loader = this.$loading.show()
      pagesRepository()
        .getPages(
          app.baseUrl,
          {MerchantId: this.$store.getters.currentMerchant},
          params,
          (params) => {return qs.stringify(params, { allowDots: true })}

        )
        .then((res) => {
          if (res.data.list != null) {
            this.pagesItems = res.data.list;
            this.pageCount = Math.ceil(res.data.totalCount / this.itemsPerPage);
          }
          else{
            this.pagesItems = []
            this.pageCount = 1
          }
          app.loadingPagesTable = false;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
      .finally(()=> loader.hide())

    },
    editPage(item) {
        this.$store.commit('setPagesFormStatus', true)
        this.$store.commit('setPagesIsEdit', true)
        this.$store.commit('setPagesSelectedForEdit', item)
    },
    deletePage(item) {
      this.$dialog.warning({
        text: `آیا از حذف صفحه <span class="red--text">${item.title}</span> اطمینان دارید؟`,
        title: "هشدار",
        actions: {
          false: {
            color: "red",
            text: "خیر",
          },
          true: {
            color: "primary",
            text: "بله",
            handle: () => {
              const loader = this.$loading.show()
              pagesRepository()
                .deletePages(item.id, this.baseUrl, {MerchantId: this.$store.getters.currentMerchant})
                .then((res) => {
                  this.fetchPagesItems();
                  this.$dialog.message.success("با موفقیت حذف گردید", {
                    position: "top-left",
                  });
                })
                .catch((error) => {
                  Helper.handleErrors(error, this);
                })
                .finally(()=> loader.hide())

            },
          },
        },
      });
    },
    changeStatus(item) {
      
      const loader = this.$loading.show();
      if (item.disabled) {
         pagesRepository()
        .disablePages(item.id, this.baseUrl, {MerchantId: this.$store.getters.currentMerchant}
        ).then(res => {
          this.$dialog.message.success("با موفقیت غیرفعال شد", {
            position: "top-left"
          });
        })
        .catch(error => {
          Helper.handleErrors(error, this);
        })
      .finally(()=> loader.hide())

     }else{
         pagesRepository()
        .enablePages(item.id, this.baseUrl, {MerchantId: this.$store.getters.currentMerchant}
        ).then(res => {
          this.$dialog.message.success("با موفقیت فعال شد", {
            position: "top-left"
          });
        })
        .catch(error => {
          Helper.handleErrors(error, this);
        })
      .finally(()=> loader.hide())

     }
    },
    changeApprovalStatus(item) {
    const loader = this.$loading.show();
      if (!item.approved) {
         pagesRepository()
        .unapprovePages(item.id, this.baseUrl, {MerchantId: this.$store.getters.currentMerchant}
        ).then(res => {
          this.$dialog.message.success("با موفقیت رد  شد", {
            position: "top-left"
          });
        })
        .catch(error => {
          Helper.handleErrors(error, this);
        })
      .finally(()=> loader.hide())

     }else{
         pagesRepository()
        .approvePages(item.id, this.baseUrl, {MerchantId: this.$store.getters.currentMerchant}
        ).then(res => {
          this.$dialog.message.success("با موفقیت تایید شد", {
            position: "top-left"
          });
        })
        .catch(error => {
          Helper.handleErrors(error, this);
        })
      .finally(()=> loader.hide())

     }
    },
    changeCommentStatus(item) {
      const loader = this.$loading.show();
      if (!item.commentable) {
         pagesRepository()
        .disableCommentPages(item.id, this.baseUrl, {MerchantId: this.$store.getters.currentMerchant}
        ).then(res => {
          this.$dialog.message.success("با موفقیت غیرفعال  شد", {
            position: "top-left"
          });
        })
        .catch(error => {
          Helper.handleErrors(error, this);
        })
      .finally(()=> loader.hide())

     }else{
         pagesRepository()
        .enableCommentPages(item.id, this.baseUrl, {MerchantId: this.$store.getters.currentMerchant}
        ).then(res => {
          this.$dialog.message.success("با موفقیت فعال شد", {
            position: "top-left"
          });
        })
        .catch(error => {
          Helper.handleErrors(error, this);
        })
      .finally(()=> loader.hide())

     }
    },
    showPage(item){
      let str = item.title.replace(/\s+/g, '-').toLowerCase();
      let pageUrl = this.$store.getters.taksaanUrl +"/contents/"+ item.id+"/supplier/"+this.$store.getters.currentMerchant +'/' + str
      window.open(pageUrl, "_blank");
 
    },
    
    publishRequest(item){
      const loader = this.$loading.show()
      pagesRepository()
      .sendpublishRequest({pageId:item.id}, this.baseUrl,{MerchantId: this.$store.getters.currentMerchant})
      .then((res)=>{
        this.$dialog.message.success("درخواست با موفقیت ارسال شد", {
            position: "top-left"
          });
          this.fetchPagesItems()
              })
              .catch((err)=>{
          Helper.handleErrors(err, this);

              })
              .finally(()=>{
                loader.hide()
              })
    }
  },
  components:{
    AdvanceFilter
  }
};
</script>

<style></style>
